import styled from "styled-components";

export const StyledCopyLink = styled.div`
  .copy-link {
    display: flex;
    align-items: center;

    .link-text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;